import { DraftedHandoffCard } from '@fruitful/agent-ui';
import { type EmailSupportWidgetProps } from '@fruitful/types';
import Clipboard from '@react-native-clipboard/clipboard';
import React, { useCallback, useState } from 'react';
import { useToastController } from 'smoothie';

import { useSendEmailToSupport } from '../../../common/hooks/useSendEmailToSupport';

export const EmailSupportWidget = ({
    subject,
    body,
}: EmailSupportWidgetProps) => {
    const sendEmailToSupport = useSendEmailToSupport();
    const toast = useToastController();
    const [isOpening, setIsOpening] = useState(false);

    const handlePress = useCallback(() => {
        if (isOpening) {
            return;
        }

        setIsOpening(true);

        void sendEmailToSupport({ subject, body }).finally(() => {
            setIsOpening(false);
        });
    }, [body, isOpening, sendEmailToSupport, subject]);

    const handleCopy = useCallback(() => {
        Clipboard.setString(body);
        toast.show('Copied!', { duration: 1000 });
    }, [body, toast]);

    return (
        <DraftedHandoffCard
            label="Email to support"
            title={subject}
            body={body}
            actionLabel="Email support"
            actionDisabled={isOpening}
            onAction={handlePress}
            onCopy={handleCopy}
        />
    );
};
